module.exports = __webpack_public_path__ + "img/moz.ef4657da.svg";